import { render } from "./PageHeaders.vue?vue&type=template&id=724e2afa&ts=true"
import script from "./PageHeaders.vue?vue&type=script&lang=ts"
export * from "./PageHeaders.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__